import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

const SortByFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    // Set default sorting value from URL or fallback to "popularity"
    const defaultSort = searchParams.get('sort') || 'popularity';

    const [selectedSort, setSelectedSort] = useState(defaultSort);

    const handleSortChange = (e) => {
        const value = e.target.value;
        setSelectedSort(value);

        // Update searchParams with the selected sort option
        searchParams.set('sort', value);
        setSearchParams(searchParams);
    };

    return (
        <div className='category-container'>
            <h2 className='text-lg text-primary font-semibold'>Sort By :</h2>
            <hr />
            <div className='mt-2' >
                <label className='category-item'>
                    <input
                        type="radio"
                        value="popularity"
                        checked={selectedSort === 'popularity'}
                        onChange={handleSortChange}
                        className="form-radio h-4 w-4 text-blue-600"
                    />
                    Most Popular
                </label>
            </div>
            <div className='mt-2' >
            <label className='category-item'>
                    <input
                        type="radio"
                        value="new_arrival"
                        checked={selectedSort === 'new_arrival'}
                        onChange={handleSortChange}
                        className="form-radio h-4 w-4 text-blue-600"
                    />
                   New Arrival
                </label>
            </div>
            <div className='mt-2' >
                <label className='category-item'>
                    <input
                        type="radio"
                        value="price-asc"
                        checked={selectedSort === 'price-asc'}
                        onChange={handleSortChange}
                        className="form-radio h-4 w-4 text-blue-600"
                    />
                    Price: Low to High
                </label>
            </div>
            <div className='mt-2' >
                <label className='category-item'>
                    <input
                        type="radio"
                        value="price-desc"
                        checked={selectedSort === 'price-desc'}
                        onChange={handleSortChange}
                        className="form-radio h-4 w-4 text-blue-600"
                    />
                    Price: High to Low
                </label>
            </div>
            <div className='mt-2' >
                <label className='category-item'>
                    <input
                        type="radio"
                        value="alphabetically"
                        checked={selectedSort === 'alphabetically'}
                        onChange={handleSortChange}
                        className="form-radio h-4 w-4 text-blue-600"
                    />
                    Alphabetically
                </label>
            </div>
            <div className='mt-2' >
                <label className='category-item'>
                    <input
                        type="radio"
                        value="rating"
                        checked={selectedSort === 'rating'}
                        onChange={handleSortChange}
                        className="form-radio h-4 w-4 text-blue-600"
                    />
                    Rating
                </label>
            </div>
        </div>
    );
};

export default SortByFilter;
